import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useTranslation } from "react-i18next";
import MicroElapsedTime from "../../lib/MicroElapsedTime";
import TruncatedTypography from "../../lib/TruncatedTypography";
import { ChatBubble, ChatHeader } from "./ChatComponents";

type Props = {
  facilityName: string;
  contents: string;
  timestamp: Date;
};

export default function AlertMessage({
  facilityName,
  contents,
  timestamp,
}: Props) {
  const { t } = useTranslation();
  return (
    <ChatBubble sx={{ background: grey[200] }}>
      <ChatHeader>
        <WarningAmberRoundedIcon sx={{ color: grey[800] }} />
        <TruncatedTypography
          variant="caption"
          sx={{
            color: "text.primary",
            ml: 0.5,
            flexGrow: 1,
            textTransform: "uppercase",
          }}
        >
          {t(`{{facilityName}} Staff`, { facilityName })}
        </TruncatedTypography>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
          }}
        >
          <MicroElapsedTime timestamp={timestamp} />
        </Typography>
      </ChatHeader>
      <Typography
        variant="body2"
        sx={{
          color: "text.primary",
        }}
      >
        {contents}
      </Typography>
    </ChatBubble>
  );
}
